import { NumericFormat } from 'react-number-format'
import { RequestNewLoanOptions, MAX_REPAYMENTS } from 'pages/loans/add/utilities'

/**
 * «چند قسط، و تا کِی لازمش داری؟»
 *
 * فوریت is not an adjective, it is a deadline — the options literally read
 * «فوری(کمتر از ۳ روز)». Rendered as tappable rows rather than a `<select>`
 * so the parenthesis, which is the actual meaning, is on screen instead of
 * hidden behind a native picker.
 *
 * The per-instalment figure is the only number the member will feel every
 * month, so it is computed live rather than left for them to divide.
 */
export default function StepTerms({
    amount,
    repayments,
    priority,
    onRepayments,
    onPriority,
    error,
}: {
    amount: string
    repayments: string
    priority: string
    onRepayments: (next: string) => void
    onPriority: (next: string) => void
    error?: string
}) {
    const count = Number(repayments) || 0
    const total = Number(amount) || 0
    const perInstallment = count > 0 ? Math.round(total / count) : 0

    return (
        <div>
            <div className=" rounded-2xl border border-stroke bg-white p-4">
                <label className=" block text-xs font-bold text-text-body">
                    تعداد اقساط
                </label>
                <NumericFormat
                    allowNegative={false}
                    decimalScale={0}
                    value={repayments}
                    inputMode="numeric"
                    placeholder="مثلاً ۱۲"
                    className=" mt-2 w-full border-b border-dashed border-stroke bg-transparent py-3 text-center text-lg font-bold outline-none"
                    onValueChange={(values) => onRepayments(values.value)}
                />
                {perInstallment > 0 && (
                    <p className=" mt-2 text-center text-xs text-text-secondary">
                        هر قسط حدود{' '}
                        <span className=" font-bold text-text-body">
                            {perInstallment.toLocaleString('fa-IR')}
                        </span>{' '}
                        تومان
                    </p>
                )}
                {error && (
                    <p className=" mt-2 text-center text-xs text-error-3">
                        {error}
                    </p>
                )}
                <p className=" mt-3 text-center text-[11px] text-text-muted">
                    حداکثر {MAX_REPAYMENTS.toLocaleString('fa-IR')} قسط
                </p>
            </div>

            <p className=" mb-2 mt-5 px-1 text-sm font-bold text-heading">
                تا کِی لازمش داری؟
            </p>
            <div className=" rounded-2xl border border-stroke bg-white px-4">
                {RequestNewLoanOptions.map((option) => (
                    <button
                        key={String(option.value)}
                        type="button"
                        onClick={() => onPriority(String(option.value))}
                        className=" flex w-full items-center justify-between gap-2 border-b border-divider py-3 text-right last:border-b-0"
                    >
                        <span className=" text-xs text-text-body">
                            {option.label}
                        </span>
                        <span
                            aria-hidden
                            className={` h-4 w-4 shrink-0 rounded-full border-2 ${
                                priority === option.value
                                    ? ' border-green-1 bg-green-1'
                                    : ' border-stroke'
                            }`}
                        />
                    </button>
                ))}
            </div>
            <p className=" mt-2 px-1 text-[11px] leading-6 text-text-muted">
                این فقط به مدیران می‌گوید چقدر عجله داری؛ ترتیب پرداخت را صندوق
                تصمیم می‌گیرد.
            </p>
        </div>
    )
}
